export default __webpack_public_path__ + "static/media/app-bar-account.002c3a81.svg";